module.exports = __webpack_public_path__ + "static/media/loyalty-card-back.3edaa0e3.png";